/**
 * Runtime configuration helper.
 *
 * In local dev, values come from Vite env vars (VITE_API_URL etc.).
 * In Docker/K8s, the entrypoint.sh injects window.__RUNTIME_CONFIG__
 * at container start, so environments can override without rebuilding.
 */

interface RuntimeConfig {
  VITE_API_URL: string;
  VITE_INTERNAL_API_URL: string;
  VITE_BASE_PATH: string;
  VITE_KEYCLOAK_URL: string;
  VITE_KEYCLOAK_REALM: string;
  VITE_KEYCLOAK_CLIENT_ID: string;
}

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: Partial<RuntimeConfig>;
  }
}

function getConfig(key: keyof RuntimeConfig, fallback: string = ''): string {
  // Runtime config (Docker/K8s) takes precedence if non-empty
  const runtimeValue = window.__RUNTIME_CONFIG__?.[key];
  if (runtimeValue) return runtimeValue;

  // Fall back to Vite build-time env
  const viteValue = import.meta.env[key];
  if (viteValue) return viteValue;

  return fallback;
}

export const config = {
  apiUrl: getConfig('VITE_API_URL', ''),
  internalApiUrl: getConfig('VITE_INTERNAL_API_URL', '') || getConfig('VITE_API_URL', ''),
  basePath: getConfig('VITE_BASE_PATH', '/'),
  keycloakUrl: getConfig('VITE_KEYCLOAK_URL'),
  keycloakRealm: getConfig('VITE_KEYCLOAK_REALM'),
  keycloakClientId: getConfig('VITE_KEYCLOAK_CLIENT_ID'),
};
